import React, { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/components/Login";
import Shell from "@/components/Shell";
import Dashboard from "@/pages/Dashboard";
import DailyEntry from "@/pages/DailyEntry";
import Customers from "@/pages/Customers";
import Menus from "@/pages/Menus";
import Cashbook from "@/pages/Cashbook";
import Vat from "@/pages/Vat";
import Ledger from "@/pages/Ledger";
import Costs from "@/pages/Costs";
import Staff from "@/pages/Staff";
import Suppliers from "@/pages/Suppliers";
import Cashflow from "@/pages/Cashflow";
import AuditLog from "@/pages/AuditLog";
import QuickEntry from "@/pages/QuickEntry";
import Shipment from "@/pages/Shipment";
import InstallPrompt from "@/components/InstallPrompt";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Loader2 } from "lucide-react";

function AppInner() {
  const { user, checking } = useAuth();
  const [tab, setTab] = useState(() => {
    const t = new URLSearchParams(window.location.search).get("tab");
    return t || (window.innerWidth < 640 ? "quick" : "dashboard");
  });
  const [dark, setDark] = useState(true);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Login />;
  const isAdmin = user.role === "admin";

  return (
    <Shell tab={tab} setTab={setTab} dark={dark} setDark={setDark}>
      <ErrorBoundary key={tab}>
      {tab === "dashboard" && <Dashboard goTo={setTab} isAdmin={isAdmin} />}
      {tab === "daily-entry" && <DailyEntry />}
      {tab === "customers" && <Customers />}
      {tab === "menus" && <Menus />}
      {tab === "cashbook" && <Cashbook />}
      {tab === "vat" && isAdmin && <Vat />}
      {tab === "ledger" && <Ledger />}
      {tab === "costs" && isAdmin && <Costs />}
      {tab === "staff" && <Staff />}
      {tab === "suppliers" && <Suppliers />}
      {tab === "cashflow" && isAdmin && <Cashflow />}
      {tab === "audit" && isAdmin && <AuditLog />}
      {tab === "quick" && <QuickEntry />}
      {tab === "shipment" && <Shipment />}
      </ErrorBoundary>
      <InstallPrompt />
    </Shell>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppInner />
        <Toaster position="top-right" richColors closeButton theme="system" />
      </AuthProvider>
    </div>
  );
}
